// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunnerOptionalParameter, HandlerWithResult } from "@insite/client-framework/HandlerCreator";
import { CustomAppState } from "@keller/App/Store/Reducers";
import cloneDeep from "lodash/cloneDeep";
import qs from "qs";

type HandlerType = HandlerWithResult<{}, string>;

export const SetFilterQuery: HandlerType = props => {
    const queryObject = cloneDeep((props.getState() as CustomAppState).xReorderPad.productFilters);

    props.result = qs.stringify(queryObject, { arrayFormat: "comma", skipNulls: true });
};

export const DispatchSetFilterQuery: HandlerType = props => {
    props.dispatch({
        type: "xReorderPad/SetFilterQuery" as any,
        result: props.result,
    });
};

export const chain = [SetFilterQuery, DispatchSetFilterQuery];

const setReorderPadFilterQuery = createHandlerChainRunnerOptionalParameter(chain, {}, "SetReorderPadFilterQuery");
export default setReorderPadFilterQuery;
